import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { Caseload } from '@/features/caseload'
import z from 'zod'

const caseloadSearchSchema = z.object({
  view: z.enum(['cards', 'table']).optional().catch('cards'),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  search: z.string().optional().catch(''),
  riskLevel: z.string().optional().catch(''),
  fundingUtilization: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/_organization/caseload/')({
  beforeLoad: async () => requireRoles(['support_coordinator']),
  validateSearch: caseloadSearchSchema,
  component: Caseload,
})
